if($('#performance-overview').length){
    var app = new Vue({
        el: '#performance-overview',
        data: {
            networks: []
        },
        methods: {
            get: function() {
                axios.get('/api/v1/active-challenges').then((response) =>  {
                    
                    response.data.forEach((network, index) => {

                        axios.get('/api/v1/network/'+network.id+'/performance').then((response) =>  {
                            response = response.data;

                            network.currentLengthRan = response.currentLengthRan;
                            network.performanceValue = response.currentApplicationsCount;
                            network.performanceTarget = Math.round((response.averageApplications / response.averageDateDiff)*response.currentLengthRan);
                            var performance = (100/network.performanceTarget)*response.currentApplicationsCount;
        
                            network.performance = performance > 100 ? 100 : performance;
                            network.performanceDays = Math.round(response.currentLengthRan);
        
                            if(performance < 33.33){
                                network.performanceLabel = 'Poor';
                                network.performanceColour = '#e20d0d';
                            }else if(performance >= 33.33 && performance < 66.66){
                                network.performanceLabel = 'Average';
                                network.performanceColour = '#f8a01c';
                            }else if(performance >= 66.66 && performance < 100){
                                network.performanceLabel = 'Good';
                                network.performanceColour = '#FFDB58';
                            }else{
                                network.performanceLabel = 'Excellent';
                                network.performanceColour = '#2dcc70';
                            }

                            this.networks.push(network);
                        }).catch((error) => {
                            this.errorHandler(error);
                        });
                    });
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getPerformance: function() {
                axios.get('/api/v1/network/'+this.networkId+'/performance').then((response) =>  {
                    response = response.data;

                    this.currentLengthRan = response.currentLengthRan;
                    this.performanceValue = response.currentApplicationsCount;
                    this.performanceTarget = Math.round((response.averageApplications / response.averageDateDiff)*response.currentLengthRan);
                    var performance = (100/this.performanceTarget)*response.currentApplicationsCount;

                    this.performance = performance > 100 ? 100 : performance;
                    this.performanceDays = Math.round(response.currentLengthRan);

                    if(performance < 33.33){
                        this.performanceLabel = 'Poor';
                        this.performanceColour = '#e20d0d';
                    }else if(performance >= 33.33 && performance < 66.66){
                        this.performanceLabel = 'Average';
                        this.performanceColour = '#f8a01c';
                    }else if(performance >= 66.66 && performance < 100){
                        this.performanceLabel = 'Good';
                        this.performanceColour = '#FFDB58';
                    }else{
                        this.performanceLabel = 'Excellent';
                        this.performanceColour = '#2dcc70';
                    }
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else if(error.response){
                    this.$toasted.error(error.response.data.message);
                }else{
                    console.log(error);
                }
            },
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        components: {
        },
        mounted () {
            this.get();
        }
    });
}